import { DraftSection } from "./DraftSection";
import { LogoutButton } from "./LogoutButton";
import { Button } from "./Button";

interface ErrorViewProps {
  message: string;
  conversationId: string;
  onRetry: () => void;
}

export function ErrorView({ message, conversationId, onRetry }: ErrorViewProps) {
  return (
    <div className="flex min-h-[calc(100vh-32px)] flex-col">
      <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
        <p className="text-sm text-red-600">{message}</p>
        <Button variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      </div>
      {conversationId && <DraftSection conversationId={conversationId} />}
      <LogoutButton />
    </div>
  );
}
